module.exports = __webpack_public_path__ + "static/media/image-992.eaf03571.jpg";